var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"clock"},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.time,'HH:mm:ss UTC'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }